export const manufacturingDataTransparencyApp = {
  id: 3,
  title: "Manufacturing Data Transparency App",
  activityId: 5,
  startDate: '2022-03-01',
  endDate: '2022-09-30',
  description: "Developed a real-time data transparency app using WPF Framework (C#, XAML, SQL), improving assembly line worker efficiency by providing actionable insights.",
  categorizedSkills: {
    profession: [
      { name: "Software Development", weight: 1 },
      { name: "Real-time Systems", weight: 0.9 },
      { name: "Data Engineering", weight: 0.7 },
      { name: "UI/UX Design", weight: 0.6 },
      { name: "Manufacturing Execution Systems", weight: 0.6 }
    ],
    language: [
      { name: "C#", weight: 1 },
      { name: "XAML", weight: 0.8 },
      { name: "SQL", weight: 0.9 }
    ],
    tools: [
      { name: "Visual Studio Enterprise", weight: 1 },
      { name: "WPF", weight: 1 },
      { name: "SQL Server", weight: 0.8 },
      { name: ".NET Framework", weight: 0.9 }
    ],
    lead: []
  },
  goal: "Improve manufacturing efficiency through real-time data insights for assembly line workers",
  detailsFile: "manufacturing-data-transparency-app.md", // Reference to markdown file
  metrics: [],
  role: "Junior Software Engineer",
  teamSize: "4",
  git: "inner source",
  link: "inner source",
  isProfessional: true,
  isVisible: true
};
